import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';

export default class CareerPathwaysLrapIndexRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;

  async model() {
    const [discovery, programs] = await Promise.all([
      this.reimaginedData.fetchLrapDiscovery(),
      this.reimaginedData.fetchLrapPrograms(),
    ]);

    return {
      discovery,
      programs,
    };
  }
}
